import { Injectable } from '@angular/core';

import { Query } from '@datorama/akita';

import { AuthUser } from '@shared/signup/models';
import { AuthRestaurantStore } from './auth-restaurant.store';

// TODO: rename
@Injectable({ providedIn: 'root' })
export class AuthRestaurantQuery extends Query<AuthUser> {
  constructor(protected readonly store: AuthRestaurantStore) {
    super(store);
  }
}
